module.exports = __webpack_public_path__ + "media/svg/mini-check-f94a3526.svg";